import { CardBrandType } from '../../../../api/types/students/credit-card-tokens/credit-card-token-entity';
import {
  CreditCardClearanceStatus,
  CreditCardClearanceType,
} from '../../../../api/types/payment-gateway/credit-card-clearance-entity';

export interface CreditCardClarenceFilterType {
  startDate: Date | null;
  endDate: Date | null;
  cardBrand: CardBrandType[];
  creditCardClearanceStatuses: CreditCardClearanceStatus[];
  creditCardClearanceType: CreditCardClearanceType[];
  statusCode: string | null;
}

export const defaultCreditCardClarenceFilter =
  (): CreditCardClarenceFilterType => ({
    startDate: null,
    endDate: null,
    cardBrand: [],
    creditCardClearanceStatuses: [],
    creditCardClearanceType: [],
    statusCode: null,
  });
